

export {
    // normalizeString,
    formatPrice,
    // formatNumberToString,
    formatStringToNumber,
    getProperTextForm,
    // formatQuantity,
    // parseInfoMessage
};

const POLISH_LETTERS = /[ółńćźżąśę\s]/gi;
const LANGUAGE = 'pl';

function normalizeString(str){
	if( str ) {
		return str.toLowerCase().replace(POLISH_LETTERS, '_');
	}
    return '';
}

/**
 * Two digits after coma, no zeros
 * @param {Number} quantity
 * @param {Boolean} returnString
 * @returns {String|Number}
 */
function formatQuantity(quantity, returnString){
	let _number = parseFloat(quantity .toFixed(2));
	return returnString ? formatNumberToString(_number): _number;
}

/**
 * Format price for display purpose
 * @param {number} price
 */
function formatPrice(price){
	let _p = '';
	if( typeof price != 'undefined' ){
		_p = price.toFixed(2).replace('.',',');
	}
    return _p;
}

/**
 * Replace dot with coma, convert number to string
 * @param {number|string} number
 * @returns {string}
 */
function formatNumberToString(number){
	let _p;
	if( typeof number === 'number' ){
		_p = String(number);
	}
	else {
		_p = number || '';
	}
    return _p.replace('.',',');
}
/**
 * Replace coma with dot
 * @param {string|number} string
 * @returns {number}
 */
function formatStringToNumber(string){
	let _p;
	if( typeof string === 'string' ){
		_p = Number(string.replace(',','.'));
	}
	else {
		_p = string || 0;
	}
    return _p;
}

/**
 *
 * @param {{ singular: string, pluralNominativ: string, pluralGenitive: string }} dictionary
 * @param {number} quantity
 */
function getProperTextForm(dictionary, quantity){
    let msg = '';
	if (dictionary) {
		if (quantity === 1) {
            msg = dictionary.singular;
        }
        else if (quantity % 10 >= 2 && quantity % 10 <= 4 && (quantity % 100 < 10 || quantity % 100 >= 20)) {
            msg = dictionary.pluralNominativ;
        }
        else {
            msg = dictionary.pluralGenitive;
        }

        msg = msg.replace('{0}', quantity);
    }

    return msg;
}

/**
 *
 * @param {String} info text||anchor|url
 * @returns {Object} { text: String, anchor: String, url: String }
 */
function parseInfoMessage(info){
	let _info = {
		text: '',
		anchor: '',
		url: ''
	}
	if( info ){
		let _arr = info.split('||');
		if( _arr.length ){
			_info.text = _arr[0];
			if( _arr[1] ){
				let _anchor = _arr[1].split('|');
				if( _anchor.length == 2 ){
					_info.anchor = _anchor[0];
					_info.url = _anchor[1];
				}
			}
		}
	}

	return _info;
}
